'use strict';
import { app } from '@/main.js'

const AuthService = {
  ssoGoogle(usertoken) {
    return new Promise((resolve, reject) => {
      app.config.globalProperties.$axios.post('/security/loginGoogleSSO', { usertoken: usertoken})
        .then(response => {
          console.log("resolve login: %O", response);
          resolve(response);
        })
        .catch(error => {
          console.log("error catcher login %O", error.response.data);
          reject(error.response.data);
        })
    })
  },
  saveUserLocal(user) {
    return new Promise((resolve, reject) => {
      app.config.globalProperties.$axios.post('/saveUserLocal', user)
        .then(response => {
          console.log("resolve login: %O", response);
          resolve(response);
        })
        .catch(error => {
          console.log("error catcher login %O", error.response.data);
          reject(error.response.data);
        })
    })
  },
  // Dev machines only: POST /api/devLogin is mounted by the local Express server
  // when LOCAL_DEV_LOGIN=true (404 otherwise) and forwards to hodim-security.
  devLogin(username, password) {
    return app.config.globalProperties.$axios.post('/devLogin', { username, password })
      .catch(error => {
        throw error.response?.data || error;
      });
  },
  loginCiamUser(token = null) {
    return new Promise((resolve, reject) => {
      const payload = token ? { usertoken: token } : {};
      const url = '/security/loginCiamUser';
      app.config.globalProperties.$axios.post(url, payload)
        .then(response => {
          console.log("resolve CIAM login: %O", response);
          resolve(response);
        })
        .catch(error => {
          console.log("error catcher CIAM login %O", error.response?.data);
          reject(error.response?.data || error);
        })
    })
  },
}
export default AuthService;

